export default "/images/83f6a54a65786b405ba6605a84bd26ab.avif";